module.exports = __webpack_public_path__ + "static/media/pin.82983b46.svg";